import { render, staticRenderFns } from "./ProductContentClassesTab.vue?vue&type=template&id=adc47580&scoped=true"
import script from "./ProductContentClassesTab.vue?vue&type=script&lang=js"
export * from "./ProductContentClassesTab.vue?vue&type=script&lang=js"
import style0 from "./ProductContentClassesTab.vue?vue&type=style&index=0&id=adc47580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc47580",
  null
  
)

export default component.exports